import { render, staticRenderFns } from "./accommodations-recap.vue?vue&type=template&id=3afe49c5&scoped=true"
import script from "./accommodations-recap.vue?vue&type=script&lang=js"
export * from "./accommodations-recap.vue?vue&type=script&lang=js"
import style0 from "./accommodations-recap.vue?vue&type=style&index=0&id=3afe49c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afe49c5",
  null
  
)

export default component.exports